import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  EXCEPTION_CATEGORY_ENUM,
  ExceptionTrackingService,
  HttpRequestMethods,
  IExceptionMetadata
} from '@com-delta-idp/mnx-utils';
import { Observable, throwError } from 'rxjs';
import {
  API_TIMEOUT,
  EndpointKeys,
  HANDLE_ERROR,
  IDP_APP
} from '../../constants/cache-header.constants';
import { EXCEPTION_FILE_NAMES } from '../../constants/exception-tracking.constants';
import { TravelDocsErrors } from '../../interface/travel-docs.interface';

@Injectable({
  providedIn: 'root'
})
export class TimaticErrorsService {
  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private exceptionTrackingService: ExceptionTrackingService
  ) {}

  getTravelDocsErrors = (): Observable<TravelDocsErrors> => {
    return new ApiBuilder<undefined, TravelDocsErrors>(
      this.http,
      this.appConfig
    )
      .app(IDP_APP)
      .endpointKey(EndpointKeys.TIMATIC_ERRORS)
      .method(HttpRequestMethods.GET)
      .errorHandler(this.handleError.bind(this))
      .timeOut(API_TIMEOUT)
      .create();
  };

  private handleError = (
    httpErrorResponse: HttpErrorResponse
  ): Observable<never> => {
    this.trackExceptions(httpErrorResponse);
    return throwError(httpErrorResponse);
  };

  private trackExceptions(httpErrorResponse: HttpErrorResponse): void {
    const exceptionMetadata: IExceptionMetadata = {
      fileName: EXCEPTION_FILE_NAMES.TIMATIC_ERRORS_SERVICE,
      methodName: HANDLE_ERROR,
      exceptionCategory: EXCEPTION_CATEGORY_ENUM.API_FAILURE,
      exceptionMessage: httpErrorResponse.error
    };
    this.exceptionTrackingService.track(
      `[${IDP_APP}]: ${httpErrorResponse.status} : ${httpErrorResponse.url}`,
      exceptionMetadata
    );
  }
}
